import * as React from 'react';
import { Avatar } from '@mui/material';
import { useRecordContext } from 'react-admin';

import { AntennaLight, AntennaSummary, ResourceLight } from '@wwf/sdk';
import { MediaDialog } from '@app/media/MediaDialog';
import { useResource } from '@app/misc/useResource';

export const AntennaAvatar = (props: {
    record?: AntennaLight | AntennaSummary;
    width?: number;
    height?: number;
    variant?: 'sm' | 'md' | 'lg' | 'xl';
    clickable?: boolean;
}) => {
    const { width, height, variant = 'md', clickable = false } = props;
    const [selectedMedia, setSelectedMedia] =
        React.useState<ResourceLight | null>(null);
    const _width =
        (width ?? variant === 'sm')
            ? 30
            : variant === 'md'
              ? 40
              : variant === 'lg'
                ? 80
                : 120;
    const _height =
        (height ?? variant === 'sm')
            ? 30
            : variant === 'md'
              ? 40
              : variant === 'lg'
                ? 80
                : 120;

    const record = useRecordContext<AntennaLight | AntennaSummary>(props);
    const { data: src } = useResource(record?.cover?.id);

    const handleImageClick = () => {
        if (record?.cover) {
            setSelectedMedia(record.cover);
        }
    };

    const handleCloseDialog = () => {
        setSelectedMedia(null);
    };

    if (src) {
        return (
            <>
                <img
                    src={src}
                    alt={''}
                    onClick={clickable ? handleImageClick : undefined}
                    style={{
                        width: _width,
                        height: _height,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        cursor: 'pointer',
                    }}
                />
                {clickable && (
                    <MediaDialog
                        selectedMedia={selectedMedia}
                        onClose={handleCloseDialog}
                    />
                )}
            </>
        );
    }

    if (!record) return null;
    return (
        <Avatar
            src={src ?? undefined}
            alt={record.name}
            sx={{
                '& img': { objectFit: 'contain' },
                width: _width,
                height: _height,
                '&.MuiAvatar-colorDefault': {
                    color: 'primary.contrastText',
                },
            }}
        >
            {record.name.charAt(0)}
        </Avatar>
    );
};
